import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('star-fill-icon', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 49 48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.143 36.193l-11.41 4.433a.645.645 0 0 1-.877-.637l.69-12.221-7.741-9.48a.645.645 0 0 1 .335-1.033l11.836-3.12L23.6 3.844a.645.645 0 0 1 1.085 0l6.625 10.293 11.836 3.12a.645.645 0 0 1 .335 1.031l-7.742 9.48.69 12.222a.645.645 0 0 1-.877.637l-11.41-4.433z",
    fill: props.colors[0],
    fillRule: "evenodd"
  }));
});